'use client';

import { BaseLayout } from 'structure/Layouts/SFILayouts/BaseLayout/BaseLayout';
import { CapitalManagerPage } from 'structure/capital-manager/components/CapitalManagerPage';

export default function CapitalManager() {
  return (
    <BaseLayout>
      <CapitalManagerPage />
    </BaseLayout>
  );
}
